export const HIDE_TRANSFER_CLASSIFIEDS_MODAL = 'hideRogueTransferModal'
